import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Alert, Button, Input, Space, Row, Col, DatePicker, Drawer, Radio, Spin } from 'antd';
import { UserOutlined } from "@ant-design/icons";
import { isMobile } from 'react-device-detect';
import { updateAppointmentStatus } from '@/redux/actions/appointmentActions';
import { getCustomerServiceConditionValues } from '@/redux/actions/customerServicesActions';
import { _newLine, customerServiceStatus, isValidDateForm, renderCustomerServiceStatus, serializeDateTime } from '@/utils/helpers';
import { buildConditionValues } from '@/components/customer-services/serviceConditionHelpers';
import AppointmentServiceConditionChecklist from './AppointmentServiceConditionChecklist';
import {
    appointmentConditionErrors,
    buildAppointmentServiceUpdates,
} from './appointmentStatusConditionHelpers';

class AppointmentUpdateStatus extends Component {
    constructor() {
        super();
        this.state = {
            requireTime: false,
            switchStatus: false,
            isStartTime: false,
            hasArrived: false,
            disabledDangtrongca: true,
            disabledDaxong: true,
            selectedStatus: null,
            conditionItems: {},
            loadedAppointmentServiceIds: [],
            isLoadingConditions: false,
            conditionLoadError: false,
            conditionErrors: {},
        };
        this.conditionLoadRequestId = 0;
    }

    componentDidUpdate(prevProps) {
        const currentId = this.props.currentItem?.id;
        const shouldLoad = this.props.visible && currentId && (
            !prevProps.visible || currentId !== prevProps.currentItem?.id
        );
        if (shouldLoad) this.loadServiceConditions(this.props.currentItem);
    }

    async loadServiceConditions(appointment) {
        const requestId = ++this.conditionLoadRequestId;
        const appointmentServices = (appointment?.services || [])
            .filter(item => item?.id && item?.customer_service?.id);

        this.setState({
            conditionItems: {},
            loadedAppointmentServiceIds: [],
            isLoadingConditions: appointmentServices.length > 0,
            conditionLoadError: false,
            conditionErrors: {},
        });

        try {
            const results = await Promise.all(appointmentServices.map(async appointmentService => {
                const values = await this.props.getCustomerServiceConditionValues(
                    appointmentService.customer_service.id
                );
                return [Number(appointmentService.id), {
                    ...appointmentService.customer_service,
                    id: Number(appointmentService.id),
                    service_group_name: appointmentService.customer_service.service?.service_group?.name || '',
                    condition_values: buildConditionValues(values, values),
                }];
            }));
            if (requestId !== this.conditionLoadRequestId || !this.props.visible) return;
            const conditionItems = results.reduce((items, [id, value]) => ({ ...items, [id]: value }), {});
            const loadedAppointmentServiceIds = results.map(([id]) => id);
            this.setState({
                conditionItems,
                loadedAppointmentServiceIds,
                conditionErrors: appointmentConditionErrors(conditionItems, loadedAppointmentServiceIds),
                isLoadingConditions: false,
            });
        } catch (error) {
            if (requestId !== this.conditionLoadRequestId || !this.props.visible) return;
            this.setState({ isLoadingConditions: false, conditionLoadError: true });
        }
    }

    changeServiceConditions = (name, value, appointmentServiceId) => {
        if (name !== 'condition_values') return;
        this.setState(state => {
            const conditionItems = {
                ...state.conditionItems,
                [appointmentServiceId]: {
                    ...state.conditionItems[appointmentServiceId],
                    condition_values: value,
                },
            };
            return {
                conditionItems,
                conditionErrors: appointmentConditionErrors(conditionItems, [appointmentServiceId]),
            };
        });
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.currentItem !== this.props.currentItem && nextProps.currentItem) {
            const current = nextProps.currentItem;

            // --- Kiểm tra dữ liệu thực tế trong DB ---
            const hasArrived = !!current?.arrived_at;
            const hasStartTime = !!current?.started_at;
            const switchStatus = current?.name === 'GOILAI';
            const status = current?.status || 'chuaden';

            // --- Xác định yêu cầu hiển thị thời gian ---
            const requireTime = switchStatus
                ? status === 'dagoi'
                : status === 'dangcho' || status === 'daden';

            const isStartTime = status === 'dangtrongca';

            // --- Điều khiển disable ---
            let disabledDangtrongca = true;
            let disabledDaxong = true;

            if (hasArrived || status === 'daden' || status === 'dangcho') {
                disabledDangtrongca = false; // Cho phép “Đang trong ca”
            }

            if (hasStartTime || status === 'dangtrongca') {
                disabledDaxong = false; // Cho phép “Đã xong”
            }

            // --- Cập nhật state ---
            this.setState({
                requireTime,
                isStartTime,
                switchStatus,
                hasArrived,
                disabledDangtrongca,
                disabledDaxong,
                selectedStatus: status,
            });

        }
    }

    // Khi bấm Cập nhật
    async handleUpdateStatus(e) {
        e.preventDefault();
        const appointmentId = this.props.currentItem?.id;
        if (!appointmentId) return;

        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                this.setState({ isLoading: true });
                try {

                    if (values.started_at) values.started_at = serializeDateTime(values.started_at, 'datetime');
                    else delete values.started_at;

                    if (values.arrived_at) values.arrived_at = serializeDateTime(values.arrived_at, 'datetime');
                    else delete values.arrived_at;

                    if (values.status === 'daxong' && this.state.conditionLoadError) {
                        this.setState({ isLoading: false });
                        return;
                    }

                    if (values.status === 'daxong') {
                        const conditionErrors = appointmentConditionErrors(
                            this.state.conditionItems,
                            this.state.loadedAppointmentServiceIds
                        );
                        if (Object.keys(conditionErrors).length > 0) {
                            this.setState({ isLoading: false, conditionErrors });
                            return;
                        }
                        values.service_status_updates = buildAppointmentServiceUpdates(
                            this.props.currentItem?.services || [],
                            values,
                            this.state.conditionItems,
                            this.state.loadedAppointmentServiceIds
                        );
                    }
                    (this.props.currentItem?.services || []).forEach((appointmentService) => {
                        const fieldName = `service_status_${appointmentService.id}`;
                        delete values[fieldName];
                    });

                    await this.props.updateAppointmentStatus(appointmentId, values);
                    this.props.reloadData();
                    this.onCancel();
                } catch (error) {
                    this.setState({ isLoading: false });
                }
            }
        });
    }

    onCancel() {
        this.conditionLoadRequestId += 1;
        this.props.form.resetFields();
        this.props.onCancel();
        this.setState({
            isLoading: false,
            requireTime: false,
            switchStatus: false,
            isStartTime: false,
            hasArrived: false,
            selectedStatus: null,
            conditionItems: {},
            loadedAppointmentServiceIds: [],
            isLoadingConditions: false,
            conditionLoadError: false,
            conditionErrors: {},
        });
    }

    changeStatus(value) {
        const { switchStatus } = this.state;
        const { currentItem } = this.props;

        // --- Kiểm tra dữ liệu thực tế trong DB ---
        const hasArrived = !!currentItem?.arrived_at;
        const hasStartTime = !!currentItem?.started_at;

        // --- Xác định yêu cầu hiển thị thời gian ---
        const requireTime = switchStatus
            ? value === 'dagoi'
            : value === 'dangcho' || value === 'daden';
        const isStart = value === 'dangtrongca';

        // --- Điều khiển disable ---
        let disabledDangtrongca = true;
        let disabledDaxong = true;

        // Nếu đã có arrived_at → cho phép “Đang trong ca”
        if (hasArrived) disabledDangtrongca = false;

        // Nếu đã có started_at → cho phép “Đã xong”
        if (hasStartTime) disabledDaxong = false;

        // Nếu người dùng vừa chọn trạng thái “Đang chờ (đã đến)” thì cho phép bước tiếp
        //if (value === 'daden' || value === 'dangcho') disabledDangtrongca = false;

        // Nếu người dùng vừa chọn “Đang trong ca” thì có thể chọn “Đã xong”
        //if (value === 'dangtrongca') disabledDaxong = false;

        // --- Cập nhật state ---
        this.setState({
            requireTime: requireTime,
            isStartTime: isStart,
            hasArrived,
            disabledDangtrongca,
            disabledDaxong,
            selectedStatus: value,
        });

    }


    render() {
        var { isLoading, requireTime, switchStatus, isStartTime, disabledDangtrongca, disabledDaxong, selectedStatus, conditionItems, isLoadingConditions, conditionLoadError, conditionErrors } = this.state;
        var { visible, currentItem } = this.props;
        const { getFieldDecorator } = this.props.form;
        const appointment = currentItem || {};
        const hasAppointment = !!appointment.id;
        const customer = appointment.customer || {};
        const appointmentServices = (Array.isArray(appointment.services) ? appointment.services : [])
            .filter(item => item && item.id && item.customer_service);

        return (
            <Drawer
                visible={visible}
                title="Cập nhật trạng thái lịch hẹn"
                onClose={() => this.onCancel()}
                maskClosable={false}
                width={isMobile ? '100%' : '50%'}
                footer={
                    <div style={{ textAlign: 'right', }}>
                        <Space>
                            <Button key="back" onClick={() => this.onCancel()}>
                                Huỷ
                            </Button>
                            <Button
                                loading={isLoading}
                                disabled={!hasAppointment || isLoadingConditions || conditionLoadError}
                                key="submit"
                                type="primary"
                                onClick={(e) => this.handleUpdateStatus(e)}
                            >
                                Cập nhật
                            </Button>
                        </Space>
                    </div>
                }
            >
                {visible && hasAppointment ?
                    <Form layout='vertical'>
                        <Row gutter={16}>
                            <Col xs={24} md={24} className='mb-3'>
                                <h6>
                                    <UserOutlined /> Khách hàng:{' '}
                                    <span className='color-primary'>
                                        {customer?.full_name || '-'} - {customer?.code || '-'}
                                    </span>
                                </h6>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} md={24}>
                                <Form.Item label="Trạng thái">
                                    {getFieldDecorator('status', {
                                        rules: [{ required: true, message: 'Vui lòng chọn trạng thái!' }],
                                        initialValue: appointment.status || (switchStatus ? 'chuagoi' : 'chuaden'),
                                    })(
                                        <Radio.Group onChange={e => this.changeStatus(e.target.value)}>
                                            {(switchStatus
                                                ? [
                                                    { value: 'chuagoi', label: 'Chưa gọi' },
                                                    { value: 'dagoi', label: 'Đã gọi' },
                                                ]
                                                : [
                                                    { value: 'daden', label: 'Đang chờ (đã đến)' },
                                                    { value: 'dangtrongca', label: 'Đang trong ca', disabled: disabledDangtrongca },
                                                    { value: 'daxong', label: 'Đã xong', disabled: disabledDaxong },
                                                    { value: 'chuaden', label: 'Chưa đến' },
                                                    { value: 'dahuy', label: 'Đã hủy' },
                                                ]
                                            ).map(opt => (
                                                <Radio key={opt.value} value={opt.value} disabled={opt.disabled}>
                                                    {opt.label}
                                                </Radio>
                                            ))}
                                        </Radio.Group>
                                    )}
                                </Form.Item>
                            </Col>
                            {isStartTime && (
                                <Col xs={24} md={24}>
                                    <Form.Item label={`Thời gian bắt đầu`}>
                                        {getFieldDecorator('started_at', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Vui lòng điền!',
                                                },
                                            ],
                                            initialValue: isValidDateForm(appointment.started_at, true)
                                        })(
                                            <DatePicker
                                                style={{ width: '100%' }}
                                                showTime={{ format: 'HH:mm' }}
                                                format="DD/MM/YYYY HH:mm"
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                            )}

                            {
                                requireTime ? (
                                    <>
                                        <Col xs={24} md={24}>
                                            <Form.Item label={`Thời điểm ${switchStatus ? 'gọi' : 'đến'}`}>
                                                {getFieldDecorator('arrived_at', {
                                                    rules: [
                                                        {
                                                            required: requireTime,
                                                            message: 'Vui lòng điền!',
                                                        },
                                                    ],
                                                    initialValue: isValidDateForm(appointment.arrived_at, true)
                                                })(
                                                    <DatePicker
                                                        style={{ width: '100%' }}
                                                        showTime={{ format: 'HH:mm' }}
                                                        format="DD/MM/YYYY HH:mm"
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </>
                                ) : null
                            }
                            {selectedStatus === 'daxong' && !switchStatus && (
                                <Col xs={24} md={24}>
                                    <Alert
                                        type="info"
                                        message="Chọn dịch vụ và các điều kiện thực tế của dịch vụ đã hoàn thành trong buổi hẹn."
                                        style={{ marginBottom: 16 }}
                                    />

                                    {conditionLoadError ? (
                                        <Alert
                                            type="error"
                                            message="Không thể tải điều kiện của dịch vụ. Vui lòng đóng form và thử lại."
                                            style={{ marginBottom: 16 }}
                                        />
                                    ) : null}
                                    <Spin spinning={isLoadingConditions}>
                                        {appointmentServices.map((appointmentService) => {
                                            const customerService = appointmentService.customer_service;
                                            const conditionItem = conditionItems[appointmentService.id];
                                            return (
                                                <div key={appointmentService.id} style={{ padding: 12, marginBottom: 12, border: '1px solid #f0f0f0', borderRadius: 4 }}>
                                                    <div style={{ marginBottom: 8 }}>
                                                        <strong>{customerService.service?.name || appointmentService.name || '-'}</strong>
                                                    </div>
                                                    <div style={{ marginBottom: 8 }}>
                                                        Trạng thái hiện tại: {renderCustomerServiceStatus(customerService.status) || '-'}
                                                    </div>
                                                    <Form.Item
                                                        label="Trạng thái thực tế sau buổi hẹn"
                                                        style={{ marginBottom: 0 }}
                                                    >
                                                        {getFieldDecorator(`service_status_${appointmentService.id}`, {
                                                            initialValue: customerService.status,
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: 'Vui lòng chọn trạng thái dịch vụ!'
                                                                }
                                                            ]
                                                        })(
                                                            <Radio.Group>
                                                                {customerServiceStatus.map(option => (
                                                                    <Radio
                                                                        key={option.value}
                                                                        value={option.value}
                                                                    >
                                                                        {option.label}
                                                                    </Radio>
                                                                ))}
                                                            </Radio.Group>
                                                        )}
                                                    </Form.Item>
                                                    {conditionItem ? (
                                                        <AppointmentServiceConditionChecklist
                                                            item={conditionItem}
                                                            onChangeItem={this.changeServiceConditions}
                                                            validationError={conditionErrors[appointmentService.id]}
                                                        />
                                                    ) : null}
                                                </div>
                                            );
                                        })}
                                    </Spin>
                                </Col>
                            )}
                            <Col xs={24} md={24}>
                                <Form.Item label="Ghi chú">
                                    {getFieldDecorator('note', {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: _newLine(appointment.note || '')
                                    })(
                                        <Input.TextArea rows={4} />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    : (visible ? <Alert type="warning" message="Chưa có dữ liệu lịch hẹn để cập nhật." /> : null)}
            </Drawer>
        )
    }
}

function mapStateToProps(state) {
    return {

    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateAppointmentStatus: (id, data) => dispatch(updateAppointmentStatus(id, data)),
        getCustomerServiceConditionValues: id => dispatch(getCustomerServiceConditionValues(id)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'AppointmentUpdateStatus' })(AppointmentUpdateStatus));
